<template>
  <b-button @click="saveAsClick" :disabled="saveAsDisabled">
    <b-icon-cloud-upload-fill aria-hidden="true"></b-icon-cloud-upload-fill>
    Copy
    <b-modal
        id="modal-save-title"
        title="Save Design As..."
        v-model="modalShow"
        @ok="saveDesign(makeCopy=true)">
      <p class="my-4">
        Save a copy of this design under a new design code.
        We recommend a different name.
      </p>

      <b-form @submit.prevent="noop">
        <b-form-group
            id="input-group-name"
            label="Give it a new name:"
            label-for="input-1"
            description="optional">
          <b-form-input
              id="name"
              v-model="design.name"
              placeholder="Untitled design"></b-form-input>
        </b-form-group>
      </b-form>

      <template v-slot:modal-ok>
          <b-icon-cloud-upload-fill aria-hidden="true"></b-icon-cloud-upload-fill>
          Save As
      </template>
    </b-modal>
  </b-button>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { BIconCloudUploadFill } from 'bootstrap-vue';

import SaveMixin from '@/mixins/SaveMixin';

export default {
  name: 'SaveDesignAs',
  components: {
    BIconCloudUploadFill,
  },
  props: {
    // msg: String,
  },
  mixins: [SaveMixin],
  data() {
    return {
      modalShow: false,
    };
  },
  computed: {
    saveAsDisabled() {
      return !this.design.image.key || !this.design.designcode;
    },
    ...mapState(['config', 'product']),
    ...mapGetters(['design']),
  },
  methods: {
    noop() {
      console.log('noop');
    },
    saveAsClick() {
      console.log('saveAsClick');
      this.modalShow = true;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
